import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button } from "../../../../components/Buttons";

export const Archive = () => {
    document.title = "Arxivləmə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Arxivləmə", value: "/products/parameters/archive", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Arxivləmə</h2>
                    <p>
                        Təchizatçıdan daxil olmayan məhsulları, anbar qalığı <b>0</b> olduqdan sonra ümumi siyahıda (anbar qalığı, kassa proqramı, məhsullar)
                        görünməməsi üçün məhsulu arxivə yerləşdirmək olar. <Button>...</Button> düyməsinə sıxıb açılan pəncərədə{" "}
                        <Button>Arxivə yerləşdir</Button> düyməsini sıxmaq lazımdır. Arxivdə olan məhsulu yenidən istifadə etmək üçün,{" "}
                        <Button>Arxivdən çıxart</Button> seçimi edilməlidir.
                    </p>
                    <img src="/images/products/parameters/archive.gif" alt="Arxivləmə" />
                </article>
            </div>
        </div>
    );
};
